module.exports = __webpack_public_path__ + "img/Schienenfahrzeug.94b5cce2.svg";